// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixData from 'wix-data';
import wixLocation from 'wix-location';

$w.onReady(async function () {
	if($w("#dynamicDataset").getCurrentItem().category === "MODELING"){
		$w("#text137").collapse()
		$w("#text139").collapse()
		$w("#text141").collapse()
		$w("#text140").collapse()
		$w("#text142").collapse()
	}
	await pageEvents();
	await shopProductsRereater();
});

async function shopProductsRereater(){
	const collectionName = $w('#dynamicDataset').getCurrentItem().title;
	const collectionItems= await wixData.query('Stores/Collections').eq('name',collectionName).find();
	const collectionId =collectionItems.items[0]._id;
	const collectionProducts = await wixData.query('Stores/Products').hasSome('collections.id',collectionId).find();
	if(collectionProducts.items.length > 0){
		$w('#shopProductsRepeater').data = collectionProducts.items;
		$w("#columnStrip11").expand()
		$w('#shopProductsRepeater').expand()
		$w("#button3").expand()
	}
	
}
async function pageEvents(){
	$w('#shopProductsRepeater').onItemReady(($item,itemData,index)=>{
		$item('#productName').text = itemData.name;
		$item('#productPrice').text = itemData.formattedPrice;
		$item('#productImage').src = itemData.mainMedia;

		$item('#productContainer').onClick(()=>{
			wixLocation.to(itemData.productPageUrl);
		});
	});
}